export function setSession(name, content) {
  sessionStorage.setItem(name, JSON.stringify(content))
}

export function getSession(name) {
  return JSON.parse(sessionStorage.getItem(name))
  console.log(name, ':', sessionStorage.getItem(name))
}

export function removeSession(name) {
  sessionStorage.removeItem(name)
}